import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, phoneMask } from '~/utils/masks';

export const HeaderUnlockedCards = [
  {
    id: 1,
    value: 'Nome completo',
    maxChar: 20,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 14,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Celular',
    maxChar: 15,
    textAlign: 'center',
  },

  {
    id: 4,
    value: 'Data Aprovação',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Data Desbloqueio',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Operador(a) de Venda',
    maxChar: 13,
  },
  {
    id: 7,
    value: 'Canal',
    maxChar: 10,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'UF',
    maxChar: 9,
    textAlign: 'center',
  },
];

export const BodyUnlockedCards = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 20,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 14,
        textAlign: 'center',
      },
      {
        value: phoneMask(i.celular).masked,
        maxChar: 15,
        textAlign: 'center',
      },

      {
        value: i.dataAprovacao
          ? moment(i.dataAprovacao).format('DD/MM/YYYY HH:mm')
          : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.cartaoAtual.dataAtivacao
          ? moment(i.cartaoAtual.dataAtivacao).format('DD/MM/YYYY HH:mm')
          : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.operador,
        maxChar: 13,
      },
      {
        value: i.origem,
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: i.uf,
        maxChar: 9,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
